// extracted by mini-css-extract-plugin
export default {"tabclix__label_radio":"radioBtn_tabclix__label_radio__xgLj0","tabclix__radio":"radioBtn_tabclix__radio__36UaW"};